import React from 'react';
import { FaArrowRight } from 'react-icons/fa'; // Import arrow icon from react-icons

const SquareButton = (props) => {
    const { value } = props;
    return (
        <button className="explore-button">
            {value} <FaArrowRight className="arrow-icon" />
        </button>
    );
};

export default SquareButton;
